module.exports = __webpack_public_path__ + "img/救赎之击.1e27b598.webp";